import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class EntriesListQueryFilter extends QueryFilter{
    organizationId: string;
}